import React from 'react';

const WebsiteSignUp = ({
  handlerSignup,
  handleStateChange,
  validator,
  state
}) => {
  return (
    <form className="nf-login-form" onSubmit={(e) => handlerSignup(e)}>
      <div className="nf-group-input">
        <input type="text" className="nf-input" value={state.fn} id="fullName" name='fn' placeholder="Full Name" onChange={(e) => handleStateChange('fn', e.target.value)} />
        {validator.message('Full Name', state.fn, 'required|required')}
      </div>
      <div className="nf-group-input">
        <input type="email" className="nf-input" value={state.e} id="email" name='e' placeholder="Email" onChange={(e) => handleStateChange('e', e.target.value)} />
        {validator.message('Email', state.e, 'required|email')}
      </div>
      <div className="nf-group-input">
        <input type="password" className="nf-input" id="password" name='pd' placeholder="Password" onChange={(e) => handleStateChange('pd', e.target.value)} />
        {validator.message('Password', state.pd, 'required|required')}
      </div>
      <span className="login-agree-text">By signing up you agree to our <a target="_blank" href="http://wisernotify.com/privacypolicy.html">Privacy</a> and <a target="_blank" href="http://wisernotify.com/terms_Conditions.html">Terms policies</a>.</span>
      <div className="nf-btn-login mt-10">
        <button className="nf-btn  nf-btn-primary   nf-btn-default" type="submit">
          Sign up
        </button>
      </div>
    </form>
  );
};

export default WebsiteSignUp;




// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js